import { getLeaveBehindSearchResults, getSearchResults, } from "../../../services/savvy";
import { ImpressionType } from "../../../lib/constants";
import Logger from "../../../lib/Logger";
import { hasDuplicateResults } from "../utils/hasDuplicateResults";
import { skipToken } from "@reduxjs/toolkit/query";
import useAppSelector from "../../../hooks/useAppSelector";
import { useEffect } from "react";
import useImpressionType from "../../../services/savvy/useImpressionType";
import useIsRemarketingSearch from "../../configuration/useIsRemarketingSearch";
var impressionType = ImpressionType.AfterClick;
export default function useLeaveBehindSearch() {
    var accountReferenceId = useAppSelector(function (state) { return state.applicant.accountReferenceId; });
    var isRemarketingSearch = useIsRemarketingSearch();
    var firstImpressionType = useImpressionType();
    var _a = getLeaveBehindSearchResults.useQueryState(accountReferenceId
        ? {
            accountReferenceId: accountReferenceId,
            impressionType: impressionType,
        }
        : skipToken, {
        selectFromResult: function (_a) {
            var data = _a.data, isSuccess = _a.isSuccess, isUninitialized = _a.isUninitialized, isLoading = _a.isLoading;
            return {
                mixedResults: data === null || data === void 0 ? void 0 : data.mixedResults,
                impressionId: data === null || data === void 0 ? void 0 : data.impressionId,
                isSuccess: isSuccess,
                isUninitialized: isUninitialized,
                isLoading: isLoading,
            };
        },
    }), mixedResults = _a.mixedResults, isSuccess = _a.isSuccess, isUninitialized = _a.isUninitialized, isLoading = _a.isLoading, impressionId = _a.impressionId;
    var firstSearchResults = getSearchResults.useQueryState(accountReferenceId
        ? {
            accountReferenceId: accountReferenceId,
            isRemarketingSearch: isRemarketingSearch,
            impressionType: firstImpressionType,
        }
        : skipToken).data;
    var hasDuplicateSearchResults = hasDuplicateResults(firstSearchResults === null || firstSearchResults === void 0 ? void 0 : firstSearchResults.mixedResults, mixedResults);
    useEffect(function () {
        if (hasDuplicateSearchResults) {
            Logger.error("Error: Leave behind search has duplicate search results", {
                firstSearchId: firstSearchResults === null || firstSearchResults === void 0 ? void 0 : firstSearchResults.impressionId,
                leaveBehindSearchId: impressionId,
            });
        }
    }, [
        hasDuplicateSearchResults,
        impressionId,
        firstSearchResults === null || firstSearchResults === void 0 ? void 0 : firstSearchResults.impressionId,
    ]);
    return {
        mixedResults: mixedResults,
        isLoading: isLoading,
        isUninitialized: isUninitialized,
        isSuccess: isSuccess,
    };
}
